var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4136_1518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9437 0H4.05634C1.81608 0 0 1.81608 0 4.05634V67.9437C0 70.1839 1.81608 72 4.05634 72H67.9437C70.1839 72 72 70.1839 72 67.9437V4.05634C72 1.81608 70.1839 0 67.9437 0Z",
    fill: "#146EB4",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9437 1.5H4.05634C2.64451 1.5 1.5 2.64451 1.5 4.05634V67.9437C1.5 69.3555 2.64451 70.5 4.05634 70.5H67.9437C69.3555 70.5 70.5 69.3555 70.5 67.9437V4.05634C70.5 2.64451 69.3555 1.5 67.9437 1.5ZM4.05634 0H67.9437C70.1839 0 72 1.81608 72 4.05634V67.9437C72 70.1839 70.1839 72 67.9437 72H4.05634C1.81608 72 0 70.1839 0 67.9437V4.05634C0 1.81608 1.81608 0 4.05634 0Z",
    fill: "#146EB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56H10.5C10.2239 56 10 56.3358 10 56.75C10 57.1642 10.2239 57.5 10.5 57.5H61.5C61.7761 57.5 62 57.1642 62 56.75C62 56.3358 61.7761 56 61.5 56Z",
    fill: "#146EB4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4074 16.3333H14.5926C12.7925 16.3333 11.3333 17.7925 11.3333 19.5926V42.4074C11.3333 44.2074 12.7925 45.6666 14.5926 45.6666H37.4074C39.2074 45.6666 40.6666 44.2074 40.6666 42.4074V19.5926C40.6666 17.7925 39.2074 16.3333 37.4074 16.3333Z",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 28.3333C22.1394 28.3333 23.3333 27.1394 23.3333 25.6667C23.3333 24.1939 22.1394 23 20.6667 23C19.1939 23 18 24.1939 18 25.6667C18 27.1394 19.1939 28.3333 20.6667 28.3333Z",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6667 36.2121L33.1667 28.3333L16.6667 45.6666",
    stroke: "#146EB4",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4136_1518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveImage);
export default __webpack_public_path__ + "static/media/active-image.29c8b6573b8982880613aca03a4b7774.svg";
export { ForwardRef as ReactComponent };